import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
const HighlyEngagedLeadIcon = props => {
  return /*#__PURE__*/_jsx(SVGIconBase, Object.assign({
    "data-test-id": "vertical-nav-icon__highly-engaged-lead"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M23.91 9.65c-1.01-.3.16.87.06 2.75-.08 1.44-1.71 2.88-2.49 2.54-.91-.4.84-5.2-1.63-9.32-2.05-3.42-8.1-6.7-7.68-5.28 2.04 6.81-5.12 10.54-6.71 14.58-1.9 4.84.15 10.97 6.42 12.73.19.05.32-.19.18-.32-1.24-1.24-2.53-2.75-2.73-4.55-.27-2.52.47-4.06.93-4.75.64-.95-.25 1.12.14 2.46.26.9 1.08 1.49 1.76 1.67.09.02.18-.06.17-.15-.06-.51-.55-1.93.73-4.96.9-2.13 3.53-4.6 4.62-4.87.21-.05.1.25.02.43-1.15 2.55-.98 4.2-.26 5.28.7 1.05 3.1 2.9 3.32 5.27.17 1.82-.16 2.95-1.15 4.08-.08.09 0 .24.12.2 3.88-1.34 7.34-5.58 7.48-10 .15-4.8-2.56-7.56-3.31-7.78z"
    })
  }));
};
export default HighlyEngagedLeadIcon;